import React, { Component } from "react";
import Bridge from "../../utils/Bridge";
import { Spin } from "antd";

import englishJson from "../../utils/language/leStudy/english.json";
import spanishJson from "../../utils/language/leStudy/spanish.json";
import noLanguageJson from "../../utils/language/leStudy/noLanguage.json";

export default class LEStudyAboutMe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_visible_first_step: false,
      loading: false,
      non_als_user: false,
      relation_to_als: "",
    };
  }
  componentDidMount() {
    this.get_participant_details();
  }
  get_participant_details = () => {
    this.setState({ loading: true });
    let params =
      "?participants_accounts_id=" +
      localStorage.getItem("ap_participants_accounts_id");
    Bridge.participants.le_study
      .get_participant_details(params)
      .then((response) => {
        console.log("response", response);
        if (response.status == 1 && response.data.length > 0) {
          this.setState({
            relation_to_als: response.data[0].relation_to_als,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  render() {
    const formData =
      this.props.language === "English"
        ? englishJson
        : this.props.language === "Spanish"
          ? spanishJson
          : noLanguageJson;
    return (
      <Spin spinning={this.state.loading}>
        <div>
          <div className="single-account">
            <a href="/personal-details" style={{ textDecoration: "none" }}>
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">{formData.page.demographicQuestions.fields.personalDetails.title}</h4>
                  <div className="completed-per yes">{formData.page.relatedWords.completed}</div>
                </div>
                <a href="/personal-details" className="update-button">
                  {formData.page.next}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          {localStorage.getItem("ap_relation_to_als") == "Living with ALS" && (
            <div className="single-account">
              <a href="/le-symptom-onset" style={{ textDecoration: "none" }}>
                <div className="block">
                  <div className="d-flex align-items-center">
                    <h4 className="mb-0 pb-0">{formData.page.demographicQuestions.fields.symptomOnset.title}</h4>
                    <div className="completed-per yes">{formData.page.relatedWords.completed}</div>
                  </div>
                  <a href="/le-symptom-onset" className="update-button">
                    {formData.page.next}{" "}
                    <box-icon
                      name="chevron-right"
                      color="#fff"
                      style={{ position: "relative", top: 0 }}
                    ></box-icon>
                  </a>
                </div>
              </a>
            </div>
          )}
          <div className="single-account">
            <a
              href="/gender-race-ethnicity-details"
              style={{ textDecoration: "none" }}
            >
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">{formData.page.demographicQuestions.fields.genderRaceEthnicity.title}</h4>
                  <div className="completed-per yes">{formData.page.relatedWords.completed}</div>
                </div>
                <a
                  href="/gender-race-ethnicity-details"
                  className="update-button"
                >
                  {formData.page.next}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          <div className="single-account">
            <a
              href="/language-education-occupation-details"
              style={{ textDecoration: "none" }}
            >
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">
                    {formData.page.demographicQuestions.fields.languageEducation.title}
                  </h4>
                  <div className="completed-per yes">{formData.page.relatedWords.completed}</div>
                </div>
                <a
                  href="/language-education-occupation-details"
                  className="update-button"
                >
                  {formData.page.next}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
          <div className="single-account">
            <a href="/medical-history" style={{ textDecoration: "none" }}>
              <div className="block">
                <div className="d-flex align-items-center">
                  <h4 className="mb-0 pb-0">{formData.page.demographicQuestions.fields.medicalHistory.title}</h4>
                  <div className="completed-per yes">{formData.page.relatedWords.completed}</div>
                </div>
                <a href="/medical-history" className="update-button">
                  {formData.page.next}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </a>
              </div>
            </a>
          </div>
        </div>
      </Spin>
    );
  }
}
